export const SET_ROUTES = 'SET_ROUTES';
export const SET_CONTENT = 'SET_CONTENT';
